export default {
    branch: 'สาขา',
    searchBranches: 'ค้นหาสาขา',
    search: 'ค้นหา',
    branchName: 'ชื่อสาขา',
    branchAddress: 'ที่อยู่สาขา',
    contactPerson: 'ผู้ติดต่อ',
    action: 'แก้ไข',
    createBranch: 'สร้างสาขา',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    deleteBranch: 'ลบสาขา',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบสาขา',
    branchIsDeleted: 'สาขาถูกลบแล้ว'
}
